// checkInConstants

export const CHECK_IN_STATUS = {
  CHECKED_IN: "checked_in",
  NOT_CHECKED_IN: "not_checked_in",
};

export const CHECK_IN_METHOD = {
  MANUAL_SEARCH: "manual_search",
};

export const DEFAULT_CHECKED_IN_BY = "check-in-staff";